<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-04-09 09:51:25
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-04-24 11:20:00
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/views/mini-h5/pages/my_home_page/components/MainPageBtn.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="box">
    <div class="item" @click="downLoad">
      <i class="iconfont icon">{{`\ue762`}}</i>
      <div class="name">{{$t('lang.t170')}}</div>
    </div>
    <div class="item" @click="editUserInfo">
      <i class="iconfont icon">{{`\ue74b`}}</i>
      <div class="name">{{$t('lang.t171')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mainpagebtn',
  props: {
    userBaseInfoVo: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {}
  },

  mounted() {},

  methods: {
    editUserInfo() {
      this.$router.push({ path: '/mini-h5/index/userRegister', query: { isEdit: true, language: this.userBaseInfoVo.language } })
    },
    downLoad() {
      this.$emit('downLoad')
    },
  },
}
</script>


<style lang="less" scoped>
.box {
  display: flex;
  justify-content: space-around;
  padding: 14px;
  .item {
    display: flex;
    align-items: center;
    .icon {
      width: 15px;
      height: 15px;
      margin-right: 5px;
    }
    .name {
      color: #575757;
      font-size: 14px;
      padding-top: 2px;
    }
  }
}
</style>